
import axios from 'axios'

const speaker_first_Query = `{documents(modelId:%20%220230c1a6-6877-4240-a6a4-08d85afe6b1b%22,%20count:50){documents{id,tagList,fieldValues},linkedDocuments{key,value{fieldValues}},totalDocuments}}`
const speaker_first_Url = `https://digitaliceland.azurewebsites.net/graphql?query=${speaker_first_Query}`

export const getSpeakers = () => {
	return axios.get(speaker_first_Url)
	.then(response => {
		//console.log(response.data.data.documents.documents)
		return response.data.data.documents.documents.map(x => x.fieldValues)
	})
}